
/**
 * @fileOverview SelectorView module definition
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/SelectorView',['require','jquery','lib/Util'],function(require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

        /**
         * This script opens and closes the product selector menus and handles
         * populating the faked text field as well as the real text field.
         * Further if hot spots are available it handles the interaction between
         * the menus and the hot spots. Take note that all animations except for
         * the slideUp and slideDown of the menu items are handled with CSS
         * transitions.
         *
         * @class SelectorView
         * @param {jQuery} $element A reference to the containing DOM element.
         * @constructor
         */
        var SelectorView = function($element) {
            /**
             * A reference to the containing DOM element.
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $element;

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             * @public
             */
            this.isEnabled = false;

            this.init();
        };

        /**
         * Initializes the UI Component View.
         * Runs a single setupHandlers call, followed by createChildren and layout.
         * Exits early if it is already initialized.
         *
         * @method init
         * @returns {SelectorView}
         * @private
         */
        SelectorView.prototype.init = function() {
            this.thisID = null;

            this.ACTIVE_CLASS = 'MMM--selectorFilter_isActive';

            this.setupHandlers()
                .createChildren()
                .layout()
                .enable();

            return this;
        };

        /**
         * Binds the scope of any handler functions.
         * Should only be run on initialization of the view.
         *
         * @method setupHandlers
         * @returns {SelectorView}
         * @private
         */
        SelectorView.prototype.setupHandlers = function() {
            // Bind event handlers scope here
            this.onMenuClickHandler = this.onMenuClick.bind(this);
            this.onHotSpotClickHandler = this.onHotSpotClick.bind(this);
            this.onMenuItemClickHandler = this.onMenuItemClick.bind(this);

            this.onHoverHandler = this.onHover.bind(this);
            this.offHoverHandler = this.offHover.bind(this);

            this.onHotSpotHoverHandler = this.onHotSpotHover.bind(this);
            this.offHotSpotHoverHandler = this.offHotSpotHover.bind(this);


            return this;
        };

        /**
         * Create any child objects or references to DOM elements.
         * Should only be run on initialization of the view.
         *
         * @method createChildren
         * @returns {SelectorView}
         * @private
         */
        SelectorView.prototype.createChildren = function() {
            this.$product = this.$element.find('.js-selectorFilter-product');
            this.$hotSpotList = this.$element.find('.js-selectorFilter-hotSpotList');
            this.$wiredSelector = this.$element.find('#wiredSelect');
            this.$productList = this.$product.find('.js-selectorFilter-product-list');

            return this;
        };

        /**
         * Remove any child objects or references to DOM elements.
         *
         * @method removeChildren
         * @returns {SelectorView}
         * @public
         */
        SelectorView.prototype.removeChildren = function() {
            this.$product = null;
            this.$hotSpotList = null;
            this.$productList = null;

            return this;
        };

        /**
         * Performs measurements and applys any positioning style logic.
         * Should be run anytime the parent layout changes.
         *
         * @method layout
         * @returns {SelectorView}
         * @public
         */
        SelectorView.prototype.layout = function() {
            return this;
        };

        /**
         * Enables the component.
         * Performs any event binding to handlers.
         * Exits early if it is already enabled.
         *
         * @method enable
         * @returns {SelectorView}
         * @public
         */
        SelectorView.prototype.enable = function() {
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

            this.$product.on('click', this.onMenuClickHandler);

            this.$productList.on('mouseover', 'a', this.onHoverHandler);
            this.$productList.on('mouseout', 'a', this.offHoverHandler);

            this.$productList.on('click', 'a', this.onMenuItemClickHandler);

            this.$hotSpotList.on('mouseover', 'a', this.onHotSpotHoverHandler);
            this.$hotSpotList.on('mouseout', 'a', this.offHotSpotHoverHandler);

            this.$hotSpotList.on('click', 'a', this.onHotSpotClickHandler);

            return this;
        };

        /**
         * Disables the component.
         * Tears down any event binding to handlers.
         * Exits early if it is already disabled.
         *
         * @method disable
         * @returns {SelectorView}
         * @public
         */
        SelectorView.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;

            this.$product.off('click', this.onMenuClickHandler);

            this.$productList.off('mouseover', 'a', this.onHoverHandler);
            this.$productList.off('mouseout', 'a', this.offHoverHandler);

            this.$hotSpotList.off('mouseover', 'a', this.onHotSpotHoverHandler);
            this.$hotSpotList.off('mouseout', 'a', this.offHotSpotHoverHandler);

            this.$hotSpotList.off('click', 'a', this.onHotSpotClickHandler);


            return this;
        };

        /**
         * Destroys the component.
         * Tears down any events, handlers, elements.
         * Should be called when the object should be left unused.
         *
         * @method destroy
         * @returns {SelectorView}
         * @public
         */
        SelectorView.prototype.destroy = function() {
            this.disable()
                .removeChildren();

            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onMenuClick
         * This handles opening and closing the menu.
         *
         * @method onMenuClick
         * @param e {Event} JavaScript event object.
         * @private
         */
        SelectorView.prototype.onMenuClick = function(e) {
            var $this = $(e.currentTarget);

            if($this.hasClass(this.ACTIVE_CLASS)) {
                $this.removeClass(this.ACTIVE_CLASS);
                $this.find('.js-selectorFilter-product-list').stop().slideUp();
            } else {
                this.closeOtherChildSelectors();
                $this.addClass(this.ACTIVE_CLASS);
                $this.find('.js-selectorFilter-product-list').stop().slideDown();
            }
        };

        /**
         * onMenuItemClick
         * This handles when a menu item is clicked on. It looks to see if the
         * clicked on item has an id if so it will activate the corresponding
         * hot spot or hot spots. Then, whether there is an id or not it populates
         * the text field with the value in the data-itemvalue place on the anchor
         * tag. It then removes the selectedCategory class from any other anchors in
         * the list and adds it to the currentTarget and replaces the text in the
         * false field with the text from the anchor.
         *
         * @method onMenuItemClick
         * @param e {Event} JavaScript event object.
         * @private
         */
        SelectorView.prototype.onMenuItemClick = function(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                //needed for IE Support
                e.returnValue = false;
            }
            var self = this;
            var $this = $(e.currentTarget);
            var value = $this.data('itemvalue');
            var $thisCategory = $this.parents('.js-selectorFilter-product');

            if($this.attr('id') !== undefined) {
                this.thisID = $this.attr('id');
                this.$hotSpotList.find('a').removeClass('MMM--selectorHotspots_isSelected');
                this.$hotSpotList.each(function() {
                    $(this).find('a[href="#' + self.thisID + '"]').addClass('MMM--selectorHotspots_isSelected');
                });
            }
            $thisCategory.find('.js-productSelect-hiddenTextField').val(value);
            $thisCategory.find('a').removeClass('MMM--selectedCategory');
            $this.addClass('MMM--selectedCategory');
            var currentCategory = $thisCategory.find('.MMM--selectedCategory').text();
            $thisCategory.find('.js-selectorFilter-product-field').text(currentCategory);
        };

        /**
         * onHotSpotClick
         * This method addresses what happens when a hot spot is clicked. First
         * the isSelected class is removed from all other hot spots then is added
         * to the selected hotspot. Then it looks at the selector that is linked
         * with the hot spot area (this.$wiredSelector) and removes the selectedCategory
         * class from all the links, and finds the link that is selected and adds the
         * selectedCategory class on to that. After that it gets the current category and
         * saves the text and value (from data-itemvalue) and places them in the false text
         * field (text) and true text field (value).
         *
         * @method onHotSpotClick
         * @param e {Event} JavaScript event object.
         * @private
         */
        SelectorView.prototype.onHotSpotClick = function(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                //needed for IE Support
                e.returnValue = false;
            }
            var $this = $(e.currentTarget);
            var selectedCategory = $this.attr('href');

            this.$hotSpotList.find('a').removeClass('MMM--selectorHotspots_isSelected');
            $this.addClass('MMM--selectorHotspots_isSelected');

            this.$wiredSelector.find('a').removeClass('MMM--selectedCategory');
            this.$wiredSelector.find(selectedCategory).addClass('MMM--selectedCategory');

            var currentCategory = this.$wiredSelector.find('.MMM--selectedCategory').text();
            var value = this.$wiredSelector.find('.MMM--selectedCategory').data('itemvalue');

            this.$wiredSelector.find('.js-productSelect-hiddenTextField').val(value);
            this.$wiredSelector.find('.js-selectorFilter-product-field').text(currentCategory);
        };

        /**
         * onHover handler.
         * This method handles what happens when a menu item is hovered over. It will
         * add an isHovered class to the corresponding hot spots.
         *
         * @method onHover
         * @param e {Event} JavaScript event object.
         * @private
         */
        SelectorView.prototype.onHover = function(e) {
            var self = this;
            var $this = $(e.currentTarget);
            this.thisID = $this.attr('id');

            this.$hotSpotList.each(function() {
                $(this).find('a[href="#' + self.thisID + '"]').addClass('MMM--selectorHotspots_isHovered');
            });

        };

        /**
         * offHover
         * This method handles what happens when a menu item is no longer being
         * hovered on. It removes the isHovered class from all hot spots.
         *
         * @method offHover
         * @param e {Event} JavaScript event object.
         * @private
         */
        SelectorView.prototype.offHover = function(e) {
            this.thisID = null;

            this.$hotSpotList.each(function() {
                $(this).find('a').removeClass('MMM--selectorHotspots_isHovered');
            });
        };

        /**
         * onHotSpotHover
         * This method handles what happens when a hot spot is hovered on.
         * First it opens up the selector that corresponds (this.$wiredSelector)
         * to the hot spots. Then it finds which category id matches the href
         * from the hovered hot spot and highlights it with the .hover class;
         *
         * @method onHotSpotHover
         * @param e {Event} JavaScript event object.
         * @private
         */
        SelectorView.prototype.onHotSpotHover = function(e) {
            var $this = $(e.currentTarget);
            var thisCategory = $this.attr('href');
            this.closeOtherChildSelectors();

            this.$wiredSelector.addClass(this.ACTIVE_CLASS);
            this.$wiredSelector.find('.js-selectorFilter-product-list').stop().slideDown();

            this.$wiredSelector.find(thisCategory).addClass('hover');
        };

        /**
         * offHotSpotHover
         * This method handles what happens when a hot spot is hovered off.
         * First it closes the selector and then removes the .hover class from
         * all menu items.
         *
         * @method offHotSpotHover
         * @private
         */
        SelectorView.prototype.offHotSpotHover = function() {
            this.$wiredSelector.removeClass(this.ACTIVE_CLASS);

            this.$wiredSelector.find('.js-selectorFilter-product-list').stop().slideUp();

            this.$wiredSelector.find('a').removeClass('hover');
        };

        /**
         * closeOtherChildSelectors
         * This method handles what happens when a hot spot is hovered off.
         * First it closes the selector and then removes the .hover class from
         * all menu items.
         *
         * @method offHotSpotHover
         * @private
         */
        SelectorView.prototype.closeOtherChildSelectors = function() {
            this.$product.removeClass(this.ACTIVE_CLASS);
            this.$element.find('.js-selectorFilter-product-list').stop().slideUp();
        };

        return SelectorView;
    });

}(MMMRequire));

